import axios from "axios";

export const getJobHeads = callback => {
  var promise = axios({
    method: "get",
    url: "/api/job_heads"
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};
